import { FormItem, Flex, Button, Form } from "@/base/components/index";
import { FieldSearch } from "@/components/field-search/components/field-search";
import { useBodyStyles } from "./body.styles";
import { useLocalization } from "@/app/hook/use-localization";
import { useSystemView } from "@/app/hook/use-system-view";
import { LocalizationText } from "@/app/index";
import { useContextSystemView } from "../../context/system-view-context";
import { SystemViewUserItemType } from "@/schemas/index";

export const BodySearch = () => {
  const { styles } = useBodyStyles();
  const localization = useLocalization();
  const systemView = useSystemView();
  const { selectedUserId, form, controllerDataTable } = useContextSystemView();

  const handleSelect = () => {
    const user = controllerDataTable.dataSource.find(
      (item) => item.Id === selectedUserId,
    );

    if (user) {
      systemView.save(user);
    } else {
      systemView.save({ Id: selectedUserId } as SystemViewUserItemType);
    }
  };

  return (
    <Form size="large" form={form} layout="vertical" autoComplete="off">
      <Flex vertical gap={24}>
        <FormItem noStyle name="query">
          <FieldSearch
            placeholder={localization.getText(
              "system.view.search.input.placeholder",
            )}
          />
        </FormItem>

        <Button
          type="primary"
          disabled={!selectedUserId}
          className={styles.tableButtonSelect}
          onClick={handleSelect}
        >
          <LocalizationText value="system.view.search.table.button.select" />
        </Button>
      </Flex>
    </Form>
  );
};
